/**
 * @typedef {import('./Props').Props} Props
 */
import React from 'react';
import { withSettings } from '../SettingProvider/SettingProvider';

/** @extends {React.Component<Props, {}, {}>} */
class TierGate extends React.Component {
	/**
	 * @returns {Props['fallback'] | Props['children']}
	 */
	render() {
		if (
			this.props.settings.isEnabled(this.props.flag, this.props.userTier)
		) {
			return this.props.children;
		}

		return this.props.fallback ?? null;
	}
}

export default withSettings(TierGate);
